// Copyright ©️ 2026 eVolve MEP, LLC

import type { ReactNode } from 'react';

import { Card, Flex } from '@mantine/core';

export const FullPageError = ({ children }: { children: ReactNode }) => (
  <Flex p="xl" h="100vh" display="flex" flex={1}>
    <Card
      radius="lg"
      display="flex"
      style={{
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        overflow: 'hidden',
        gap: 'md',
      }}
      bg="#3a3b3c"
      c="app-shell-gray.0"
      ta="center"
      flex="1"
    >
      {children}
    </Card>
  </Flex>
);
